import type { PropsWithChildren } from 'react'
import { createContext, useContext, useState } from 'react'
import { assert } from '../../asserts'
import { Tracker } from './Tracker'
import type { TrackerConfig } from './Tracker'

export const TrackerContext = createContext<Tracker>(
  new Tracker({ finalizePayload: {}, startPayload: {} })
)

export interface TrackerProviderProps extends PropsWithChildren {
  config: TrackerConfig
}

export function TrackerProvider(props: TrackerProviderProps) {
  const [tracker] = useState(() => new Tracker(props.config))

  return (
    <TrackerContext.Provider value={tracker}>
      {props.children}
    </TrackerContext.Provider>
  )
}
export function useTracker() {
  return useContext(TrackerContext)
}
